import { Navigation } from 'components/Navigation/Navigation';
import { FC, ReactNode } from 'react';
import { BodyContainer, MainContainer, PageContainer } from './Page.styles';

const Page: FC<{ children: ReactNode }> = ({ children, ...props }) => {
  return (
    <PageContainer {...props}>
      <Navigation />
      <BodyContainer>
        <MainContainer>{children}</MainContainer>
      </BodyContainer>
    </PageContainer>
  );
};

export default Page;
